/**
 * Discover's tile headings are display labels, not taxonomy names, so slugifying them lands on a
 * different page than the category: "Asian Antiques" gives `/c/asian-antiques/`, a noindex keyword
 * page, where the category is `/c/asian/` (its taxonomy name is just "Asian"). The three entries
 * below are the browse slugs those labels stand for -- don't collapse this into `urlSafeTitle`.
 */
export const urlToSend = (title: string) => {
    let categoryTitle = title;
    switch (title) {
        case 'asian antiques':
            categoryTitle = 'asian';
            break;

        case 'home & décor':
            categoryTitle = 'home-and-decor';
            break;

        case 'coins':
            categoryTitle = 'coins-currency-and-stamps';
            break;

        default:
            title;
    }
    return categoryTitle;
};
